import React from 'react';
import InputDefault from '../InputDefault';
import { EditavelContainer, ViewModeText, EditModeContainer, ErrorMessage } from '../EditavelCommon/styles';
import { applyCepMask, applyProcessoMask } from '../../../utils/masks';

interface InputEditavelProps {
    value: string | number | undefined;
    onChange: (value: string) => void;
    isEditing: boolean;
    label?: string;
    placeholder?: string;
    mask?: string;
    required?: boolean;
    error?: string;
    disabled?: boolean;
    type?: 'text' | 'password' | 'email' | 'tel' | 'number';
    onBlur?: () => void;
}

const InputEditavel: React.FC<InputEditavelProps> = ({
    value,
    onChange,
    isEditing,
    label,
    placeholder,
    mask = '',
    required = false,
    error,
    disabled = false,
    type = 'text',
    onBlur,
}) => {
    const formatValueForDisplay = (val: string | number | undefined): string => {
        if (val === undefined || val === null || val === '') return 'N/A';
        
        const stringValue = String(val);
        
        if (mask === '99999-999') {
            return applyCepMask(stringValue);
        }
        
        if (mask === '0000000-00.0000.0.00.0000' || mask === '9999999-99.9999.9.99.9999') {
            return applyProcessoMask(stringValue);
        }
        
        return stringValue;
    };

    // Se estiver desabilitado, sempre mostra modo visualização
    if (disabled || !isEditing) {
        return (
            <EditavelContainer>
                <ViewModeText>
                    {formatValueForDisplay(value)}
                </ViewModeText>
                {error && <ErrorMessage>{error}</ErrorMessage>}
            </EditavelContainer>
        );
    }

    // Para máscara de processo, o react-input-mask funciona melhor com apenas números
    // Ele aplica a máscara automaticamente durante a digitação
    const getValueForInput = () => {
        if (!value) return '';
        const stringValue = String(value);
        // Para máscara de processo, sempre retorna apenas números
        // O react-input-mask vai aplicar a formatação automaticamente
        if (mask === '9999999-99.9999.9.99.9999') {
            // Remove qualquer formatação existente e retorna apenas números
            return stringValue.replace(/\D/g, '');
        }
        return stringValue;
    };

    return (
        <EditavelContainer>
            <EditModeContainer>
                <InputDefault
                    type={type}
                    value={getValueForInput()}
                    onChangeText={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    mask={mask}
                    disabled={disabled}
                    title={label}
                    obrigatorio={required}
                    error={error}
                />
            </EditModeContainer>
        </EditavelContainer>
    );
};

export default InputEditavel;

